var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.list.length
    ? _c("table", { staticClass: "meneta", staticStyle: { width: "100%" } }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "tbody",
          _vm._l(_vm.formattedList, function(item) {
            return _c("tr", { key: item.id }, [
              _c("td", { domProps: { textContent: _vm._s(item.post_title) } }),
              _vm._v(" "),
              _c("td", { domProps: { textContent: _vm._s(item.rdco_type) } }),
              _vm._v(" "),
              _c("td", [_c("img", { attrs: { src: item.thumbail_url } })]),
              _vm._v(" "),
              _c("td", { attrs: { align: "center" } }, [
                _vm.seeSpecifications
                  ? _c("a", {
                      staticClass: "pdf-icon",
                      attrs: { href: item.pdf_download, target: "_blank" }
                    })
                  : _vm._e(),
                _vm._v(" "),
                !_vm.seeSpecifications
                  ? _c("a", {
                      staticClass: "fancybox pdf-icon",
                      attrs: { href: "#login", target: "_blank" }
                    })
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("td", [
                _c("div", { staticClass: "button small sky-blue right" }, [
                  _vm.seeSpecifications
                    ? _c("a", { attrs: { href: item.permalink } }, [
                        _vm._v("View details →")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.seeSpecifications
                    ? _c(
                        "a",
                        {
                          staticClass: "fancybox",
                          attrs: { href: "#login", target: "_blank" }
                        },
                        [_vm._v("View details →")]
                      )
                    : _vm._e()
                ])
              ])
            ])
          }),
          0
        )
      ])
    : _vm.loading
    ? _c("p", [_vm._v("Loading shims...")])
    : _vm.fetchedData
    ? _c("p", [_vm._v("No results")])
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("td", { attrs: { width: "15%" } }, [_vm._v("Name")]),
        _vm._v(" "),
        _c("td", { attrs: { width: "20%" } }, [_vm._v("Base Material")]),
        _vm._v(" "),
        _c("td", { attrs: { width: "23%" } }, [_vm._v("Shim Construction")]),
        _vm._v(" "),
        _c("td", { attrs: { width: "20%", align: "center" } }, [
          _vm._v("Download")
        ]),
        _vm._v(" "),
        _c("td", { attrs: { width: "22%" } }, [_vm._v(" ")])
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-26375682", { render: render, staticRenderFns: staticRenderFns })
  }
}